export default "__VITE_ASSET__B1uVfMC0__"